import style from "../../../../assets/scss/sub/purchase/orderAndPayment.module.scss";
import CartProductItems from "../CartProductItems";
import React from "react";
import {useAppSelector} from "../../../../hooks/hooks";
import {cartedProducts} from "../../../../store/cart/cartSlice";

export function OrderProductsField() {
    const cartedProductList = useAppSelector(cartedProducts);

    return (
        <div className={style.orderAndPaymentWrapper}>
            <div className={style.orderItemList}>
                <h3 className={style.sectionTitle}>주문상품</h3>
                <CartProductItems cartedProducts={cartedProductList ?? []}/>
            </div>
        </div>
    )
}